export default "__VITE_ASSET__D6GPXa3m__"